const tempData = {
  success: true,
  count: 11,
  allCampaigns: [
    {
      overview: {
        campaignName: "Positive Vibes",
        campaignType: "OPEN",
        description:
          "Welcome to the Positive Vibes Campaign - a way for everyone to get involved and join youth on a mission to support children and young people in need. \n\nHow does it work?\nThere are youth projects around the world that need your help. You can support by buying one of the image impact tokens created by youth and other supporters OR contributing an image that will be sold as an impact token. \n\nIf you buy one of the images, this will be an impact token that builds your impact portfolio that you can share, AND it will also be your token ticket to the Positive Vibes Festival for Youth Day 2024.  If you contribute an image, you can also earn from it if its bought – and it will then be an impact token ticket too.\n\nWe are also working to twin schools and organisations with projects in need. We don't ask for a lot, all you need is a bit of inspiration to create some images or awesome photos that can be contributed to a campaign. Once you have these, add it to a campaign, promote it to your networks to get them supporting AND you earn while supporting a project of your choice while building your impact portfolio! Get in touch at aunuaglobal.org to find out more about how this works, and you can check out some of the projects you could twin with to support here: https://impactoverse.com/browse-sub-campaign/63c42a6b4df378abfe55cd84\n\nWhat will funds from this campaign support?\n1) By October of 2023 we aim to raise $1000 to support at least 10 sub-campaigns aimed at improving the lives of children and young people with their Positive Vibes campaigns so that they can fundraise for their own needs. \n2) By January 2024 we aim to raise $10 000 to build out the ROAR app that supports youth with training and support on their impact journeys, and that also gives them an outlet for their creativity through AUNUA Stage - our youth media programme. We aim to onboard at least 200 children and young people by this time.\n3) By August 2024 we aim to have raised $30 000, (alongside additional sponsorships), to build out the AUNUA Youth Academy in the Metaverse of Impact, giving youth opportunities without borders. \n\nMore on the Positive Vibes Movement:\nAUNUA Global in Partnership with Skyler Jett and his charity Music for Global Change, launched the Positive Vibes Movement which champions more positive action that leads to more positive vibes around the world. What would YOUR world be like with more love and kindness?! Let's find out with Positive Vibes! Find out more on aunuaglobal.com\n\n",
        startDate: "2023-01-15T18:59:14.000Z",
        endDate: "2024-08-31T14:59:14.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1674828850697_653000_Positive-Vibes-Banner.jpg",
        ],
        isSuperCampaign: true,
        isSubCampaign: false,
        superCampaignId: "",
        superCampaignName: "",
        country: "United Kingdom",
      },
      impact: {
        category: "Children",
        milestones: [],
      },
      _id: "63c42a6b4df378abfe55cd84",
      userId: "63c3e0964df378abfe55cc94",
      brandId: "63c3e85f4df378abfe55ccd9",
      causeId: "",
      isFeatured: true,
    },
    {
      overview: {
        campaignName: "A World of Wonder",
        campaignType: "CLOSED",
        description:
          "Many of us have been incredibly lucky to see as much of the world as we have and the more we see the more aware we become of the unique needs and diverse challenges of different places. Adventurelogue was a way to combine the love of travel with a means to give back to the communities and destinations that make traveling so addictive for us. Our proceeds support projects like Project Peru (check out our website for more info https://adventurelogue.co.uk) and if you support with the purchase of an Impact Art, we can either donate a travel diary to a refuge or shelter, or we can post it out to you if you're in the UK. Please contact us for shipping costs overseas. Additionally, all Impact Arts sold on our campaign will also give you access to an online concert and metaverse festival with some great talents (more info coming soon!) and you can find out more here https://www.aunuaglobal.org/positive-vibes",
        startDate: "2023-02-21T20:47:12.000Z",
        endDate: "2023-11-30T17:47:12.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1677007504495_840448_adveturelogue(920Ã411px).png",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
        country: "United Kingdom",
      },
      impact: {
        category: "International Aid",
        milestones: [],
      },
      _id: "63f51a90c040bbe49f9b0dba",
      userId: "63d6f06a7bf683b8c836c25b",
      brandId: "",
      causeId: "63e004f4c040bbe49f9aff9e",

      isFeatured: false,
    },
    {
      overview: {
        campaignName: "SaferWays Kids",
        campaignType: "CLOSED",
        description:
          "We want the world to be a safer place and are supporting SaferWays (see saferways.info) to develop a program called SaferWays Kids, developing fun info packs that teach kids about safety. In aid of this we are releasing our limited edition Bears. When you buy one of the Bear Impact Arts you also get a Bear Martial Arts t-shirt shipped out to you. Contact us through bearmartialarts.com with proof of your purchase and we'll arrange shipping, OR we can donate the tee to a local youth project. BONUS: Your Impact Art also gives you access to the Positive Vibes Festival in August! Check out positivevibesglobal.com for more info and updates. ",
        startDate: "2023-03-20T21:13:58.000Z",
        endDate: "2024-02-19T15:13:58.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1679263703208_968836_f4b94d81-b49b-47f6-9fe9-06cb90155c28.png",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
        country: "United Kingdom",
      },
      impact: {
        category: "Children",
        milestones: [],
      },
      _id: "6418152cc1877fb6b1264437",
      userId: "63d6eed57bf683b8c836c24a",
      brandId: "",
      causeId: "63e0053fc040bbe49f9affa8",
      isFeatured: false,
    },

    {
      overview: {
        country: "",
        campaignName: "She Hygiene",
        campaignType: "OPEN",
        description:
          "She Hygiene is an initiative by We Rise Together that focuses on distributing bio-degradable sanitary pads to girls and women who cannot afford to buy these basic necessities and we also educate them regarding the importance of menstrual health. \r\n\r\nOur vision is to provide access to eco-friendly sanitary products to reduce the staggering numbers of schoolgirls dropping out because of unhygienic menstruation. We believe menstrual hygiene is a basic right, not a luxury. \r\n\r\nOur monthly target is to provide pads to  300 women and girls, every month, who struggle to practice safe and healthy menstrual hygiene.\r\n\r\nWe have conducted several drives in:\r\nslum areas, girls' orphanages and  schools teaching deprived girls.\r\n\r\nThrough our educational sessions, we have broken down the taboo surrounding menstruation due to which our target audience is able to freely discuss their period problems and also encourage their friends, sister and mothers to use pads as well. \r\n\r\nThis has reduced their period problems and offered a better menstrual health to many.\r\n\r\nRecently, we have also started promoting the use of other sustainable options like Menstrual Cups.",
        startDate: "2023-03-21T00:03:52.000Z",
        endDate: "2023-12-20T00:03:52.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1679295021370_782963_5bf27f5d-317b-4bc6-a809-27ce66fab31a.jpg",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
      },
      impact: {
        category: "Health",
        milestones: [],
      },
      _id: "64183c3bc1877fb6b12644ab",
      userId: "641023bdc1877fb6b126390a",
      brandId: "",
      causeId: "640b37dfc1877fb6b1263641",
      isFeatured: false,
    },
    {
      overview: {
        campaignName: "Esther's Orphanage ",
        campaignType: "OPEN",
        description:
          "This is a campaign that is part of the Positive Vibes movement. We hope that you will support us and spread more positive vibes!!\n\nThe Orphanage is run by Esther who first realised what it felt like to be helpless after losing her dad. She was determined to help other children so that they would never need to experience the same struggles that she had.\n\nShe started the orphanage by supporting 3 children and this has grown with her now looking after the needs of 20, from ages 3 upward.   The orphanage, predominantly through Esther, provides support and security of a home for these vulnerable children who are entirely dependent on the orphanage for their education, clothing, food, shelter and well-being. \n\nDespite Esther's noble intentions for these children and to save them from suffering, life is still a struggle as the orphanage is largely dependent on donations which are in short support. Esther is running this campaign to reduce the dependency on donations, to provide a more sustainable solution to the hunger the children face and a long term solution for their well-being. \n\nFood security is important and this campaign is to fundraise for some land, animals and provisions for a vegetable garden so that the orphanage can be more self-sufficient and less reliant on donations. Please support our campaign by buying an image or event contributing an image and sharing with your network. \n\nThis campaign is a part of the Positive Vibes Super Campaign so all Impact Arts will also give the owners entry to The Positive Vibes Festival in August. More info can be found at aunuaglobal.com. \n\n",
        startDate: "2023-03-20T11:28:58.000Z",
        endDate: "2024-02-29T10:28:58.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1679308253392_667901_b8890f59-3a62-4675-8926-9a8d4f5d47f1.jpg",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
        country: "Zambia",
      },
      impact: {
        category: "Health",
        milestones: [],
      },
      _id: "6416fb5cc1877fb6b1264098",
      userId: "63c3e0964df378abfe55cc94",
      brandId: "63c3e85f4df378abfe55ccd9",
      causeId: "",
      isFeatured: false,
    },
    {
      overview: {
        campaignName: "Road to Education ",
        campaignType: "OPEN",
        description:
          "We want to buy a school bus for vulnerable kids to help them reach school in the morning. Children from age 3 have to walk over 7km to get to our charity school where we provide free education, meals and resources. \n\nWe need lots of support but we think a bus is a priority to start as these children face many dangers on the walk and some have to leave home at 5am to get to school at 8:30am and then get home at 7:30pm. \n\nA school bus will cost $12,821 and we hope that you will buy the art which will show your support for us and when you buy the kids art it will also be a ticket to the positive vibes festival - see positivevibesglobal.com \n\nWe can make a difference to these children's lives. ",
        startDate: "2023-05-01T07:26:00.000Z",
        endDate: "2023-12-31T10:30:00.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1680964069102_585789_1a7d6211-d174-41bd-b180-e662d2286e0a.jpg",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
        country: "Tanzania",
      },
      impact: {
        category: "Education",
        milestones: [],
      },
      _id: "643179e5d001d4fd2f5e63e5",
      userId: "641addefff96c10593df6507",
      brandId: "",
      causeId: "641ee6faff96c10593df779a",
      isFeatured: false,
    },
    {
      overview: {
        campaignName: "Canine Superheroes",
        campaignType: "OPEN",
        description:
          "This is for dog lovers all around the world! And... you don't need to know what an Impact Art is or how to create one. It's really easy to get involved, all you need is an image of your dog that you love, that will forever be linked to a digital token, (that's the Impact Art) AND when you buy the Impact Art you'll be supporting a dog in need, and possibly save it's life. \r\n\r\nThe harsh reality is that euthanasia is common 'solution' for dogs with behavioral issues, often only because they've had limited socialization or training, and because their owners have had limited instruction on how to integrate their fur babies into the world. \r\n\r\nWe want to help give these amazing companions a fighting chance by working with animal shelters to offer training and support for pups and hopefully their new forever humans. \r\n\r\nFor every $300 that we earn from your Impact Art creations and sales we will support 10 dogs in an animal shelter with socialization and training. 10 % of earnings will also be donated to the animal shelter for other resources that they need. \r\n\r\nSteps to help:\r\n1) Just sign up\r\n2) Verify your account, (you have to get verified through the Stripe payment gateway because on this platform, people can earn from Impact Art creations and sales too so if you chose to support a campaign and earn from sales they need a way to pay you!\r\n3) On our campaign page, click on Contribute an Impact Art, and add the details for the image, choose what percentage of the sale you want to give to our campaign, (if you're buying the Impact Art or you don't want to earn from the sale, please choose 100%), and click on create.\r\n4)Once you've created the image, you can then buy it, or share it with your network for someone else to purchase and support our campaign. \r\n\r\nWe really hope that you will support us on this. The pup you love can help save others! \r\n\r\nP.S. If you want to add some cool effects to your images before you add them, there are lots of free online options to do that, including one called Nightcafe studio (creator.nightcafe.studio) which gives you free credits. ",
        startDate: "2023-05-26T12:23:30.000Z",
        endDate: "2024-03-31T12:23:30.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1682436337463_597427_89e40922-0202-4340-99dd-db6de5cc4dfe.png",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "64181f64c1877fb6b1264456",
        superCampaignName: "PetDrops",
        country: "United Kingdom",
      },
      impact: {
        category: "Animal Welfare",
        milestones: [],
      },
      _id: "6447f0f11fbc6ac0dfdbdde7",
      userId: "63d6f0d97bf683b8c836c266",
      brandId: "",
      causeId: "63e00bddc040bbe49f9b001d",
      isFeatured: false,
    },

    {
      overview: {
        campaignName: "Water for Life",
        campaignType: "OPEN",
        description:
          "THE CONTEXT:\nWe have come a long way over the last year, and we have the opportunity to do so much more, but trying to get everything done with limited resources and while working as volunteers, has been tough. We have two major initiatives that we would love support on, one that focuses on education and the other on technology. \n\nEDUCATION:\nWith the education program, Embark is interested in working with us so that we might develop an environmental education program. The aim would be  to support students, initially in a pilot followed by a rollout to 38 schools with education, practical skills and collaborative experiences through accelerators and incubators to raise awareness of the challenges, and to accelerate development of solutions. We want to develop this program with them and then be able to support schools and programs everywhere, both in the UK and internationally to do the same, creating a ripple effect of behavioural change and rapid solution deployment. \n\nWe are looking to raise £25 000 to support with the initial development, pilot and rollout of the program. \n\nTECHNOLOGY:\nThe second area that we need support with, is to help us develop technology that will clean rivers and prevent plastic from reaching the ocean. Existing solutions focus just on the river surface, but we are working in partnership to develop a technology that also lifts and captures plastic from the riverbed. We are finalizing this project and will run a separate campaign for this in time, but would love for you to get in touch if you would like to partner, sponsor or support in some other way. \n\nHOW TO GET INVOLVED:\n1) Buy an image, when you do it will be an Impact Art that will build your impact portfolio and impact profile. Show the world what you stand for.\n2) Share an original image of yours- something that is water themed, it could be a drawing, a photo, some AI art, and promote it so that it sells. Even if it's just for $10, every small amount matters so help us to save the world! NB- YOU CAN EARN FROM IMAGES WHEN THEY SELL & YOU CAN ALSO OFFER BUYERS ADDITIONAL VALUE FROM THE IMAGES (for example anyone who buys the image also gets a physical item, or access to an experience or a product or service).\n3) Run your own sub-campaign under our super campaign to fundraise for water initiatives and programs. Anything that is focused on protecting our water resources, fresh water and salt water... and the ecosystems around them. We want to give you a voice and a means to do this. Remember, you don't need to know anything about Impact Arts, and you can get others to contribute too. \n\nNote: If you're a school or a youth organisation, run an activity day to fundraise for any of your impact activities and for us too :) You can also get involved in the Positive Vibes Movement. Get in touch to find out more. \n\nFind us at thinkocean.earth\n",
        startDate: "2023-05-01T04:39:17.000Z",
        endDate: "2024-09-30T04:39:17.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1682840487380_582018_3397b0b7-fbfa-49b3-8410-d739cf41a969.png",
        ],
        isSuperCampaign: true,
        isSubCampaign: false,
        superCampaignId: "",
        superCampaignName: "",
        country: "United Kingdom",
      },
      impact: {
        category: "Environment",
        milestones: [],
      },
      _id: "644e1ba84d7c29c3de584700",
      userId: "6409c469c1877fb6b1263492",
      brandId: "",
      causeId: "644d3dbb4d7c29c3de5844a7",
      isFeatured: false,
    },
    {
      overview: {
        campaignName: "Action for Equality",
        campaignType: "OPEN",
        description:
          "About the Cause \nWe've come together as a group of refugees to help Afghan girls and young women overcome barriers to access of third level online learning opportunities (for undergraduate and graduate degrees). We have fled from war-torn areas, including Afghanistan and the Ukraine, but now in a safer place, believe that we have to stand up and do what we can to empower others.\n\nIn December 2022, an institutional decision was made through Taliban rule that banned girls and women from being able to access education. No debate or argument or lobbying has as yet changed this. \nWe embody the struggle for women's right, where education is one of the main and primary human rights.  Afghanistan is the only country where girls and women do NOT have the right to study. Any protests are met with threats of physical harm. The psychological harm is constant. \nOur aim is to prevent the girls from extinguishing the dreams in their hearts. Education is the way to a better future and the realization of dreams. This is the main purpose of what we are doing. \nBy supporting our campaign, you open the door for many Afghan girls and women to realize their dreams.  You give a lifeline to hope and faith for a brighter future for them.  You create an opportunity for them to get out of a life of oppression and inequality.  Education should be a right, help us to make this a reality, prove that equality stands a chance. \nWe know that there are many who will say that there are lots of online courses that women can access, and there are also some universities that offer scholarships. This is a great resource BUT there are still barriers to accessing this. Even for those who have the technology, there is limited internet access, not because of internet not being available generally, but lack of funds to purchase data which is expensive. Even for girls who have good proficiency in English, they don't have the means to get the English tests required that certifies their proficiency and allows for them to overcome this hurdle which is a pre-requisite for the university sponsored positions. We would love to be able to work with universities all around the world to be able to offer accredited opportunities for these girls and women, but to start we need to overcome these initial hurdles. \nWe would like to raise funds for the following:\n- Internet access for 60 girls and young women at $15 per month, for 3 months to complete the English certifications ($900 x 3: Total of $2700)\n- The IELTS test for 60 girls and young women at $200 per person (Total of $12 000) We would also welcome any test provider being able to sponsor these tests and universities and other training providers being able to offer subsidised positions. \nWe understand that there are many challenges but we have to try to make a difference. By supporting us, you support a fairer world, and you take a stand against inequality. \n",
        startDate: "2023-06-08T02:00:00.000Z",
        endDate: "2030-02-07T20:41:55.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1686181053140_688039_4bb666a5-5074-4673-a355-0dc82a5e496e.jpg",
        ],
        isSuperCampaign: false,
        isSubCampaign: false,
        superCampaignId: "",
        superCampaignName: "",
        country: "Afghanistan",
      },
      impact: {
        category: "Education",
        milestones: [],
      },
      _id: "648114bd2e4e15627b786187",
      userId: "64189faac1877fb6b12645a3",
      brandId: "",
      causeId: "646367692079da1f93a1c2d6",

      isFeatured: false,
    },
  ],
};

import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { tranding_category_filter } from "../../data/categories_data";
import { HeadLine } from "../../components/component";
import Feature_collections_data from "../../data/Feature_collections_data";
import Collection_dropdown from "../../components/dropdown/collection_dropdown";
import Explore_collection_item from "../../components/collectrions/explore_collection_item";
import Meta from "../../components/Meta";
import { collectCollectionData } from "../../redux/counterSlice";
import { useDispatch } from "react-redux";
import Image from "next/image";
import Collection_category_filter from "../../components/collectrions/collection_category_filter";
import {
  CampaignSvg,
  CountrySvg,
  ImpactCategorySvg,
  SuperCampaignSvg,
} from "../../components/svg/svgFilesGlobal";
import Pagination from "../../components/Pagination/Pagination";
import CampaignsSortFilter from "../../components/campaigns/CampaignsSortFilter";
import SearchClearButton from "../../components/common/SearchClearButton";

const ITEMS_PER_PAGE = 60;

const initialFilters = {
  searchQuery: "",
  impactCategory: "",
  country: "",
  sortBy: "recently_created",
  isFeatured: false,
  organizationType: "",
  superCampaign: "",
};

const Explore_campaigns = () => {
  // State management
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [allData, setAllData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewMode, setViewMode] = useState("grid"); // 'grid' or 'list'
  const [showFilters, setShowFilters] = useState(false);

  // Filter states
  const [filters, setFilters] = useState(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState(initialFilters);
  const [filtersChanged, setFiltersChanged] = useState(false);

  // Options for filters
  const [impactCategoryOptions, setImpactCategoryOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [superCampaignOptions, setSuperCampaignOptions] = useState([]);

  // Legacy state (for compatibility)
  const [selectedImpactCategoryOptions, setSelectedImpactCategoryOptions] =
    useState([]);
  const [selectedCountryOptions, setSelectedCountryOptions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Data fetching
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_BASE_URL}/api/app/all-campaigns`,
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.success) {
          setAllData(data);

          const uniqueImpactCategories = [
            ...new Set(
              data.allCampaigns.map((campaign) => campaign.impact.category),
            ),
          ].filter((category) => category && category.trim() !== "");
          setImpactCategoryOptions(uniqueImpactCategories);

          const uniqueCountries = [
            ...new Set(
              data.allCampaigns.map((campaign) => campaign.overview.country),
            ),
          ].filter((country) => country && country.trim() !== "");
          setCountryOptions(uniqueCountries);

          const superCampaigns = data.allCampaigns
            .filter((c) => c.overview.isSuperCampaign)
            .map((c) => c.overview.campaignName)
            .filter(Boolean);
          setSuperCampaignOptions(superCampaigns);
        } else {
          throw new Error(data.message || "Failed to fetch campaigns");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load campaigns. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Track filter changes
  useEffect(() => {
    const hasChanges =
      JSON.stringify(filters) !== JSON.stringify(appliedFilters);
    setFiltersChanged(hasChanges);
  }, [filters, appliedFilters]);

  // Handlers
  const handleInputChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setFilters((prev) => ({
      ...prev,
      [name]: newValue,
    }));
    // Selects/checkboxes apply instantly; the free-text search is debounced below
    if (name !== "searchQuery") {
      setAppliedFilters((prev) => ({
        ...prev,
        [name]: newValue,
      }));
      setCurrentPage(1);
    }
  }, []);

  // Debounced apply for the free-text search (Enter still applies immediately)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setAppliedFilters((prev) =>
        prev.searchQuery === filters.searchQuery
          ? prev
          : { ...prev, searchQuery: filters.searchQuery },
      );
      setCurrentPage(1);
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [filters.searchQuery]);

  // Clearing applies straight away rather than waiting out the search debounce
  const handleSearchClear = useCallback(() => {
    setFilters((prev) => ({ ...prev, searchQuery: "" }));
    setAppliedFilters((prev) => ({ ...prev, searchQuery: "" }));
    setCurrentPage(1);
  }, []);

  const applyFilters = useCallback(() => {
    setAppliedFilters({ ...filters });
    setFiltersChanged(false);
    setCurrentPage(1);
  }, [filters]);

  const clearAllFilters = useCallback(() => {
    setFilters(initialFilters);
    setAppliedFilters(initialFilters);
    setFiltersChanged(false);
    setCurrentPage(1);
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      applyFilters();
    }
  };

  const handleSortChange = useCallback((sortValue) => {
    setFilters((prev) => ({ ...prev, sortBy: sortValue }));
    setAppliedFilters((prev) => ({ ...prev, sortBy: sortValue }));
    setCurrentPage(1);
  }, []);

  const handleViewToggle = (view) => {
    setViewMode(view);
  };

  const handlePageChange = useCallback((pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Filter and sort campaigns
  const filteredAndSortedCampaigns = useMemo(() => {
    if (!allData || !allData.allCampaigns) return [];

    // Get hidden campaign IDs from environment variable
    const hiddenIds = (process.env.NEXT_PUBLIC_HIDDEN_CAMPAIGN_IDS || '')
      .split(',')
      .map(id => id.trim())
      .filter(Boolean);

    let filtered = allData.allCampaigns.filter((campaign) => {
      // Exclude hidden campaigns
      if (hiddenIds.includes(campaign._id)) {
        return false;
      }
      const matchesSearch =
        !appliedFilters.searchQuery ||
        campaign.overview.campaignName
          .toLowerCase()
          .includes(appliedFilters.searchQuery.toLowerCase()) ||
        campaign.overview.description
          .toLowerCase()
          .includes(appliedFilters.searchQuery.toLowerCase());

      const matchesImpactCategory =
        !appliedFilters.impactCategory ||
        campaign.impact.category === appliedFilters.impactCategory;

      const matchesCountry =
        !appliedFilters.country ||
        campaign.overview.country === appliedFilters.country;

      const matchesFeatured = !appliedFilters.isFeatured || campaign.isFeatured;

      // Organization type filter (filter by whether campaign is from a Brand or a Cause)
      let matchesOrganization = true;
      if (appliedFilters.organizationType) {
        if (appliedFilters.organizationType === "cause") {
          // Show campaigns that support a cause (have supportedCauseId)
          matchesOrganization = campaign.isCauseCampaign;
        } else if (appliedFilters.organizationType === "brand") {
          // Show campaigns created by brand users
          matchesOrganization = campaign.isBrandCampaign;
        }
      }

      let matchesSuperCampaign = true;
      if (appliedFilters.superCampaign) {
        if (appliedFilters.superCampaign === "super_only") {
          matchesSuperCampaign = campaign.overview.isSuperCampaign === true;
        } else {
          // Show the super campaign itself and all its sub-campaigns
          matchesSuperCampaign =
            campaign.overview.campaignName === appliedFilters.superCampaign ||
            campaign.overview.superCampaignName === appliedFilters.superCampaign;
        }
      }

      return (
        matchesSearch &&
        matchesImpactCategory &&
        matchesCountry &&
        matchesFeatured &&
        matchesOrganization &&
        matchesSuperCampaign
      );
    });

    // Sort campaigns
    switch (appliedFilters.sortBy) {
      case "recently_created":
        filtered.sort(
          (a, b) =>
            new Date(b.overview.startDate) - new Date(a.overview.startDate),
        );
        break;
      case "ending_soon":
        filtered.sort(
          (a, b) => new Date(a.overview.endDate) - new Date(b.overview.endDate),
        );
        break;
      case "alphabetical_a_z":
        filtered.sort((a, b) =>
          a.overview.campaignName.localeCompare(b.overview.campaignName),
        );
        break;
      case "alphabetical_z_a":
        filtered.sort((a, b) =>
          b.overview.campaignName.localeCompare(a.overview.campaignName),
        );
        break;
      default:
        break;
    }

    return filtered;
  }, [allData, appliedFilters]);

  // Pagination
  const totalItems = filteredAndSortedCampaigns.length;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const displayedCampaigns = filteredAndSortedCampaigns.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE,
  );

  const hasActiveFilters =
    JSON.stringify(appliedFilters) !== JSON.stringify(initialFilters);

  // Legacy handlers for compatibility
  const handleCheckboxChange = (e, setOptions) => {
    const value = e.target.value;
    setOptions((prevOptions) =>
      e.target.checked
        ? [...prevOptions, value]
        : prevOptions.filter((option) => option !== value),
    );
  };

  const handleRemoveOption = (option, setOptions) => {
    setOptions((prevOptions) =>
      prevOptions.filter((prevOption) => prevOption !== option),
    );
  };

  // Loading State
  if (loading) {
    return (
      <>
        <Meta title="Explore Campaigns || Impactoverse" />
        <main className="min-h-screen bg-jacarta-50 dark:bg-jacarta-900 pt-20">
          {/* Hero Section */}
          <section className="bg-white dark:bg-jacarta-800 border-b border-jacarta-100 dark:border-jacarta-600">
            <div
              className="container mx-auto"
              style={{ padding: 'clamp(1.5rem, 4vw, 2.5rem) clamp(1rem, 3vw, 2rem)' }}
            >
              <div className="text-center">
                <h1
                  className="font-bold text-jacarta-700 dark:text-white"
                  style={{ fontSize: 'clamp(1.5rem, 4vw, 2rem)' }}
                >
                  Explore Campaigns
                </h1>
                <p
                  className="text-jacarta-500 dark:text-jacarta-300 mt-2"
                  style={{ fontSize: 'clamp(0.875rem, 2vw, 1rem)' }}
                >
                  Discover impactful campaigns from around the world
                </p>
              </div>
            </div>
          </section>

          {/* Loading Content */}
          <section style={{ padding: 'clamp(1.5rem, 4vw, 2.5rem) 0' }}>
            <div
              className="container mx-auto"
              style={{ padding: '0 clamp(1rem, 3vw, 2rem)' }}
            >
              <div
                className="flex flex-col lg:flex-row"
                style={{ gap: 'clamp(1rem, 3vw, 1.5rem)' }}
              >
                {/* Skeleton Sidebar */}
                <div className="hidden lg:block lg:w-64 lg:flex-shrink-0">
                  <div
                    className="bg-white dark:bg-jacarta-700 rounded-xl sm:rounded-2xl border border-jacarta-100 dark:border-jacarta-600"
                    style={{ padding: 'clamp(1rem, 3vw, 1.5rem)' }}
                  >
                    <div className="space-y-5">
                      {Array.from({ length: 5 }).map((_, index) => (
                        <div key={index}>
                          <div className="h-4 bg-grayish/20 dark:bg-jacarta-600 rounded w-20 mb-2 animate-pulse"></div>
                          <div className="h-10 bg-grayish/20 dark:bg-jacarta-600 rounded-lg animate-pulse"></div>
                        </div>
                      ))}
                      <div className="flex gap-2 pt-2">
                        <div className="h-10 bg-grayish/20 dark:bg-jacarta-600 rounded-lg flex-1 animate-pulse"></div>
                        <div className="h-10 bg-grayish/20 dark:bg-jacarta-600 rounded-lg w-16 animate-pulse"></div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Skeleton Content */}
                <div className="flex-1 min-w-0">
                  <div
                    className="bg-white dark:bg-jacarta-800 rounded-xl sm:rounded-2xl border border-jacarta-100 dark:border-jacarta-600"
                    style={{ padding: 'clamp(1rem, 3vw, 1.5rem)', marginBottom: 'clamp(1rem, 3vw, 1.5rem)' }}
                  >
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                      <div className="h-6 bg-grayish/20 dark:bg-jacarta-600 rounded w-32 animate-pulse"></div>
                      <div className="flex gap-3">
                        <div className="h-10 bg-grayish/20 dark:bg-jacarta-600 rounded-lg w-40 animate-pulse"></div>
                        <div className="h-10 bg-grayish/20 dark:bg-jacarta-600 rounded-lg w-20 animate-pulse"></div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="grid"
                    style={{
                      gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))',
                      gap: 'clamp(1rem, 3vw, 1.5rem)'
                    }}
                  >
                    {Array.from({ length: 12 }).map((_, index) => (
                      <div
                        key={index}
                        className="bg-white dark:bg-jacarta-700 rounded-xl sm:rounded-2xl border border-jacarta-100 dark:border-jacarta-600 overflow-hidden"
                      >
                        <div className="aspect-[16/9] bg-grayish/20 dark:bg-jacarta-600 animate-pulse"></div>
                        <div style={{ padding: 'clamp(0.75rem, 2vw, 1rem)' }}>
                          <div className="h-5 bg-grayish/20 dark:bg-jacarta-600 rounded w-3/4 mb-2 animate-pulse"></div>
                          <div className="h-3 bg-grayish/20 dark:bg-jacarta-600 rounded w-1/2 mb-3 animate-pulse"></div>
                          <div className="h-3 bg-grayish/20 dark:bg-jacarta-600 rounded w-full mb-1 animate-pulse"></div>
                          <div className="h-3 bg-grayish/20 dark:bg-jacarta-600 rounded w-2/3 animate-pulse"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </>
    );
  }

  // Error State
  if (error) {
    return (
      <>
        <Meta title="Explore Campaigns || Impactoverse" />
        <main className="min-h-screen bg-jacarta-50 dark:bg-jacarta-900 pt-20">
          {/* Hero Section */}
          <section className="bg-white dark:bg-jacarta-800 border-b border-jacarta-100 dark:border-jacarta-600">
            <div
              className="container mx-auto"
              style={{ padding: 'clamp(1.5rem, 4vw, 2.5rem) clamp(1rem, 3vw, 2rem)' }}
            >
              <div className="text-center">
                <h1
                  className="font-bold text-jacarta-700 dark:text-white"
                  style={{ fontSize: 'clamp(1.5rem, 4vw, 2rem)' }}
                >
                  Explore Campaigns
                </h1>
                <p
                  className="text-jacarta-500 dark:text-jacarta-300 mt-2"
                  style={{ fontSize: 'clamp(0.875rem, 2vw, 1rem)' }}
                >
                  Discover impactful campaigns from around the world
                </p>
              </div>
            </div>
          </section>

          {/* Error Content */}
          <section style={{ padding: 'clamp(1.5rem, 4vw, 2.5rem) 0' }}>
            <div
              className="container mx-auto"
              style={{ padding: '0 clamp(1rem, 3vw, 2rem)' }}
            >
              <div className="max-w-lg mx-auto">
                <div
                  className="bg-white dark:bg-jacarta-800 rounded-xl sm:rounded-2xl border border-jacarta-100 dark:border-jacarta-600 text-center"
                  style={{ padding: 'clamp(2rem, 6vw, 3rem) clamp(1.5rem, 4vw, 2rem)' }}
                >
                  <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-8 h-8 sm:w-10 sm:h-10 text-red-500 dark:text-red-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.084 16.5c-.77.833.192 2.5 1.732 2.5z"
                      />
                    </svg>
                  </div>
                  <h3
                    className="font-semibold text-jacarta-700 dark:text-white mb-2"
                    style={{ fontSize: 'clamp(1rem, 2.5vw, 1.25rem)' }}
                  >
                    Error Loading Campaigns
                  </h3>
                  <p className="text-sm sm:text-base text-jacarta-500 dark:text-jacarta-400 mb-6">
                    {error}
                  </p>
                  <button
                    onClick={() => window.location.reload()}
                    className="px-6 py-3 sm:py-2.5 bg-accent text-white rounded-full sm:rounded-lg font-medium hover:bg-accent-dark active:scale-95 transition-all"
                  >
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          </section>
        </main>
      </>
    );
  }

  return (
    <>
      <Meta title="Explore Campaigns || Impactoverse" />

      <main className="min-h-screen bg-jacarta-50 dark:bg-jacarta-900 pt-20">
        {/* Hero Section */}
        <section className="bg-white dark:bg-jacarta-800 border-b border-jacarta-100 dark:border-jacarta-600">
          <div
            className="container mx-auto"
            style={{ padding: 'clamp(1.5rem, 4vw, 2.5rem) clamp(1rem, 3vw, 2rem)' }}
          >
            <div className="text-center">
              <h1
                className="font-bold text-jacarta-700 dark:text-white"
                style={{ fontSize: 'clamp(1.5rem, 4vw, 2rem)' }}
              >
                Explore Campaigns
              </h1>
              <p
                className="text-jacarta-500 dark:text-jacarta-300 mt-2"
                style={{ fontSize: 'clamp(0.875rem, 2vw, 1rem)' }}
              >
                Discover impactful campaigns from around the world
              </p>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section style={{ padding: 'clamp(1.5rem, 4vw, 2.5rem) 0' }}>
          <div
            className="container mx-auto"
            style={{ padding: '0 clamp(1rem, 3vw, 2rem)' }}
          >
            <div
              className="flex flex-col lg:flex-row"
              style={{ gap: 'clamp(1rem, 3vw, 1.5rem)' }}
            >
              {/* Mobile Filter Toggle */}
              <div className="lg:hidden">
                <button
                  onClick={() => setShowFilters(!showFilters)}
                  className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-3 bg-white dark:bg-jacarta-700 border border-jacarta-100 dark:border-jacarta-600 rounded-xl text-jacarta-700 dark:text-white hover:border-accent transition-colors font-medium"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z"
                    />
                  </svg>
                  {showFilters ? "Hide Filters" : "Show Filters"}
                  {filtersChanged && (
                    <div className="w-2 h-2 bg-accent rounded-full"></div>
                  )}
                </button>
              </div>

              {/* Sidebar - Desktop always visible, Mobile toggleable */}
              <div
                className={`lg:w-64 lg:flex-shrink-0 ${showFilters ? "block" : "hidden lg:block"}`}
              >
                <div
                  className="bg-white dark:bg-jacarta-700 rounded-xl sm:rounded-2xl border border-jacarta-100 dark:border-jacarta-600"
                  style={{ padding: 'clamp(1rem, 3vw, 1.5rem)' }}
                >
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      applyFilters();
                    }}
                    className="space-y-6"
                  >
                    {/* Search */}
                    <div>
                      <label className="block text-sm font-medium text-jacarta-700 dark:text-white mb-2">
                        Search Campaigns
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          name="searchQuery"
                          value={filters.searchQuery}
                          onChange={handleInputChange}
                          onKeyPress={handleKeyPress}
                          placeholder="Search by name or description..."
                          className="w-full px-3 pr-9 py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white placeholder-jacarta-500 dark:placeholder-jacarta-400 focus:border-accent focus:ring-2 focus:ring-accent/20"
                        />
                        {filters.searchQuery && (
                          <SearchClearButton
                            onClear={handleSearchClear}
                            className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5"
                            label="Clear campaign search"
                          />
                        )}
                      </div>
                    </div>

                    {/* Impact Category */}
                    <div>
                      <label className="block text-sm font-medium text-jacarta-700 dark:text-white mb-2">
                        Impact Category
                      </label>
                      <select
                        name="impactCategory"
                        value={filters.impactCategory}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white focus:border-accent focus:ring-2 focus:ring-accent/20"
                      >
                        <option value="">All Categories</option>
                        {impactCategoryOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Country */}
                    <div>
                      <label className="block text-sm font-medium text-jacarta-700 dark:text-white mb-2">
                        Country
                      </label>
                      <select
                        name="country"
                        value={filters.country}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white focus:border-accent focus:ring-2 focus:ring-accent/20"
                      >
                        <option value="">All Countries</option>
                        {countryOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Organization Type */}
                    <div>
                      <label className="block text-sm font-medium text-jacarta-700 dark:text-white mb-2">
                        Organization Type
                      </label>
                      <select
                        name="organizationType"
                        value={filters.organizationType}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white focus:border-accent focus:ring-2 focus:ring-accent/20"
                      >
                        <option value="">All Organizations</option>
                        <option value="brand">Brands</option>
                        <option value="cause">Causes</option>
                      </select>
                    </div>

                    {/* Super Campaign */}
                    {superCampaignOptions.length > 0 && (
                      <div>
                        <label className="block text-sm font-medium text-jacarta-700 dark:text-white mb-2">
                          Super Campaign
                        </label>
                        <select
                          name="superCampaign"
                          value={filters.superCampaign}
                          onChange={handleInputChange}
                          className="w-full px-3 py-2 border border-jacarta-100 dark:border-jacarta-600 rounded-lg bg-white dark:bg-jacarta-800 text-jacarta-700 dark:text-white focus:border-accent focus:ring-2 focus:ring-accent/20"
                        >
                          <option value="">All Campaigns</option>
                          <option value="super_only">Super Campaigns Only</option>
                          {superCampaignOptions.map((name) => (
                            <option key={name} value={name}>
                              {name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* Featured */}
                    <div>
                      <label className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          name="isFeatured"
                          checked={filters.isFeatured}
                          onChange={handleInputChange}
                          className="w-4 h-4 text-accent bg-white border-jacarta-200 rounded focus:ring-accent focus:ring-2"
                        />
                        <span className="text-sm text-jacarta-700 dark:text-white">
                          Featured Only
                        </span>
                      </label>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-2">
                      <button
                        type="submit"
                        disabled={!filtersChanged}
                        className={`flex-1 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                          filtersChanged
                            ? "bg-accent text-white hover:bg-accent-dark"
                            : "bg-jacarta-100 dark:bg-jacarta-600 text-jacarta-500 dark:text-jacarta-400 cursor-not-allowed"
                        }`}
                      >
                        Apply Filters
                      </button>
                      <button
                        type="button"
                        onClick={clearAllFilters}
                        disabled={!hasActiveFilters}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                          hasActiveFilters
                            ? "bg-jacarta-100 dark:bg-jacarta-600 text-jacarta-700 dark:text-white hover:bg-jacarta-200 dark:hover:bg-jacarta-500"
                            : "bg-jacarta-50 dark:bg-jacarta-700 text-jacarta-400 dark:text-jacarta-500 cursor-not-allowed"
                        }`}
                      >
                        Clear
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              {/* Content Area */}
              <div className="flex-1 min-w-0">
                {/* Content Header */}
                <div
                  className="bg-white dark:bg-jacarta-800 rounded-xl sm:rounded-2xl border border-jacarta-100 dark:border-jacarta-600"
                  style={{ padding: 'clamp(1rem, 3vw, 1.5rem)', marginBottom: 'clamp(1rem, 3vw, 1.5rem)' }}
                >
                  <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex flex-wrap items-center gap-3">
                      <h2
                        className="font-semibold text-jacarta-700 dark:text-white"
                        style={{ fontSize: 'clamp(1rem, 2vw, 1.125rem)' }}
                      >
                        {totalItems.toLocaleString()} Campaigns
                      </h2>
                    </div>

                    {/* Mobile: Stack vertically, Desktop: Side by side */}
                    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
                      {/* Sort Filter */}
                      <div className="flex items-center gap-3">
                        <label className="text-sm text-jacarta-600 dark:text-jacarta-300 whitespace-nowrap">
                          Sort:
                        </label>
                        <div className="flex-1 sm:flex-initial">
                          <CampaignsSortFilter
                            onSortChange={handleSortChange}
                            currentSort={appliedFilters.sortBy}
                          />
                        </div>
                      </div>

                      {/* View Toggle */}
                      <div className="flex justify-center sm:justify-start">
                        <div className="flex bg-jacarta-100 dark:bg-jacarta-600 rounded-lg p-1">
                          <button
                            onClick={() => handleViewToggle("grid")}
                            className={`flex items-center justify-center w-8 h-8 rounded-md transition-all ${
                              viewMode === "grid"
                                ? "bg-white shadow-sm text-accent"
                                : "text-jacarta-600 dark:text-jacarta-400 hover:text-accent"
                            }`}
                            title="Grid View"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width={16}
                              height={16}
                              className="fill-current"
                            >
                              <path d="M3 3H11V11H3V3ZM3 13H11V21H3V13ZM13 3H21V11H13V3ZM13 13H21V21H13V13Z" />
                            </svg>
                          </button>

                          <button
                            onClick={() => handleViewToggle("list")}
                            className={`flex items-center justify-center w-8 h-8 rounded-md transition-all ${
                              viewMode === "list"
                                ? "bg-white shadow-sm text-accent"
                                : "text-jacarta-600 dark:text-jacarta-400 hover:text-accent"
                            }`}
                            title="List View"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width={16}
                              height={16}
                              className="fill-current"
                            >
                              <path d="M11 4H21V6H11V4ZM11 8H17V10H11V8ZM11 14H21V16H11V14ZM11 18H17V20H11V18ZM3 4H9V10H3V4ZM3 14H9V20H3V14Z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Main Content Area */}
                {totalItems > 0 ? (
                  <div
                    className={viewMode === "list" ? "space-y-4" : "grid"}
                    style={viewMode === "grid" ? {
                      gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))',
                      gap: 'clamp(1rem, 3vw, 1.5rem)'
                    } : undefined}
                  >
                    <Explore_collection_item
                      itemFor="explore-collection"
                      selectedCountries={selectedCountryOptions}
                      selectedImpactCategory={selectedImpactCategoryOptions}
                      searchedObject={{}}
                      allData={{ ...allData, allCampaigns: displayedCampaigns }}
                      viewMode={viewMode}
                    />
                  </div>
                ) : (
                  <div
                    className="flex flex-col items-center justify-center text-center bg-white dark:bg-jacarta-800 rounded-xl sm:rounded-2xl border border-jacarta-100 dark:border-jacarta-600"
                    style={{ padding: 'clamp(2rem, 6vw, 4rem) clamp(1rem, 3vw, 2rem)' }}
                  >
                    <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-jacarta-50 dark:bg-jacarta-700 flex items-center justify-center mb-4">
                      <svg className="w-8 h-8 sm:w-10 sm:h-10 text-jacarta-300 dark:text-jacarta-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                      </svg>
                    </div>
                    <p
                      className="font-semibold text-jacarta-700 dark:text-white mb-2"
                      style={{ fontSize: 'clamp(1rem, 2.5vw, 1.25rem)' }}
                    >
                      No Campaigns Found
                    </p>
                    <p className="text-sm sm:text-base text-jacarta-500 dark:text-jacarta-400 max-w-md">
                      {hasActiveFilters
                        ? "Try adjusting your filters to find what you're looking for."
                        : "No campaigns are currently available. Check back soon!"}
                    </p>
                    {hasActiveFilters && (
                      <button
                        onClick={clearAllFilters}
                        className="mt-6 px-6 py-2.5 bg-accent hover:bg-accent-dark text-white rounded-full font-medium transition-colors text-sm sm:text-base"
                      >
                        Clear All Filters
                      </button>
                    )}
                  </div>
                )}

                {/* Pagination */}
                {totalPages > 1 && (
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Explore_campaigns;
